import { Retailer101 } from '@at/track-types'

export const retailerContext = (id: string): Retailer101 => {
    return {
        SCHEMA_KEY: 'Retailer101',
        id: id || '',
    }
}
